/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationMoveEnumOption
 */
export interface AdminStockAdjustLocationMoveEnumOption {
    /**
     * 枚举值（对应 separateStore）
     * @type {number}
     * @memberof AdminStockAdjustLocationMoveEnumOption
     */
    value?: number;
    /**
     * 显示名称
     * @type {string}
     * @memberof AdminStockAdjustLocationMoveEnumOption
     */
    label?: string;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationMoveEnumOption interface.
 */
export function instanceOfAdminStockAdjustLocationMoveEnumOption(value: object): value is AdminStockAdjustLocationMoveEnumOption {
    return true;
}

export function AdminStockAdjustLocationMoveEnumOptionFromJSON(json: any): AdminStockAdjustLocationMoveEnumOption {
    return AdminStockAdjustLocationMoveEnumOptionFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationMoveEnumOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationMoveEnumOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function AdminStockAdjustLocationMoveEnumOptionToJSON(json: any): AdminStockAdjustLocationMoveEnumOption {
    return AdminStockAdjustLocationMoveEnumOptionToJSONTyped(json, false);
}

export function AdminStockAdjustLocationMoveEnumOptionToJSONTyped(value?: AdminStockAdjustLocationMoveEnumOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

